export class CashRegisterPairLocalRequest {
    cashRegisterId?: number;
    accessToken?: string;
} 